import { Control, Controller } from "react-hook-form";

import { VerticalSpace } from "components/VerticalSpace/VerticalSpace";
import { NamedInput } from "components/NamedInput/NamedInput";
import { HorizontalSpace } from "components/HorizontalSpace/HorizontalSpace";

import styles from "./styles.module.scss";

type Props = {
  control: Control<any>;
  isEdit: boolean;
};

export const OptBody = ({ control, isEdit }: Props): JSX.Element => {
  return (
    <div className={styles.container}>
      <VerticalSpace size={16} />
      <div className="flex flex-row justify-between">
        <Controller
          name="name"
          control={control}
          render={({ field }) => (
            <NamedInput
              {...field}
              label="Название"
              type="text"
              isRequired
              inputWidth={300}
            />
          )}
        />
        <HorizontalSpace size={27} />

        {isEdit && (
          <Controller
            name="id"
            control={control}
            render={({ field }) => (
              <NamedInput {...field} label="Код" inputWidth={100} disabled />
            )}
          />
        )}
      </div>
    </div>
  );
};
